import React, {useContext} from "react";
import './ModalAndModalContent.css'
import {ViewMangementContext} from "../StatesMangement/InitialiseContext";
import {Elink} from "./Routes";
import {Link} from "react-router-dom";

const DefaultModal = () => {
    // This component is Default Modal in this app.
    // This is custom Modal so we can change the Body of Modal and also we can change the Modal Title.
    // Example :- Just call the function like this to show alert.
    // "setModalContent({ Title: 'Any Title', Body: {Any Component or Html Tags}, Class: 'Any Class for (custom style)'}),
    const PageView = useContext(ViewMangementContext)
    const ClearModal = () => {
        localStorage.setItem("loading", "no")
        PageView.setModalContent({Title: '', Body: '', Class: ''})
    }
    const Modal = PageView.ModalContent
    return (
            <div className={"modal fade " + Modal.Class} id="Modal" tabIndex="-1" role="dialog"
                 aria-labelledby="ModalLabel" aria-hidden="true" >
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content" id={Modal.Class} style={Modal.Class === "inventory-list" || Modal.Class === "inventory-list percentage" ? {marginTop: "2%"} : {marginTop: "0"} }>
                        <div className="modal-header">
                            <h5 className="modal-title" id="ModalLabel">{Modal.Title}</h5>
                            {/* Add custom inventory link button for itemized inventory type ...*/}
                            <div style={ Modal.Class === "inventory-list" ? {display: "block"}:{display: "none"}} className="col text-right p-0">
                                    <button type={"submit"} className={"btn btn-active btn-sm"} style={{borderRadius: "8px", background: "#0cbeef"}}>
                                        <Link to={`/client_estimate_mobile_link?elink=${Elink}`} target={'_blank'}>
                                            <p style={{color: "white", margin: "0px", cursor: "pointer"}}>Click here to go to the mobile friendly version.</p>
                                        </Link>
                                    </button>
                            </div>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true" onClick={()=>ClearModal()}>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            {Modal.Body}
                        </div>
                    </div>
                </div>
            </div>
    );
}
export default DefaultModal;